import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withFormik, Form } from 'formik';
import { StripeProvider, Elements } from 'react-stripe-elements';
import TextInput from '../../../components/molecule/FormFields/TextInput';
import Button from '../../../components/atomic/Buttons/Button';
import { formBase, isSubmitted, submitExerciseForm } from '../../../modules/ExerciseForm';
import styled from 'styled-components';
import { createPaymentIntent } from '../../../services/apiServices';
import { setGlobalLoadingSpinner } from '../../../modules/GlobalUI';
import config from '../../../core/config';
import PaymentForm from './PaymentForm';

const Container = styled.div`
  width: 75%;
`;
const FormStyled = styled(Form)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const TextInputStyled = styled(TextInput)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 0 10px;
  margin-bottom: 10px;
  border-radius: 10px;
`;
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
  width: 75%;
`;
const ButtonStyled = styled(Button)`
  margin-left: 8px;
`;

const RowStyled = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
`;
const ColumnStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  margin: 2px;
`;
const ColumnHeader = styled(ColumnStyled)`
  font-size: 20px;
  font-weight: 600;
  text-align: center;
`;

class Transfer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      clientSecret: null,
      error: null,
      success: false
    };
  }

  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  handleSubmit = async (values) => {
    this.props.setGlobalLoadingSpinner(true, 'getting results...');

    try {
      const results = await createPaymentIntent(values.stripeAccount, values.amount);
      this.setState({
        clientSecret: results.client_secret,
        error: null,
      });
    } catch(e) {
      this.setState({
        clientSecret: null,
        error: e.message,
      });
    }

    this.props.setGlobalLoadingSpinner(false);
  }

  handlePaymentSubmit = results => {
    console.log("handlePaymentSubmit results:", results);
    if (results.error) {
      this.setState({ error: results.error });
    } else {
      this.setState({ success: true });
    }
  }

  resetPaymentForm = () => {
    this.props.resetForm();
    this.setState({
      clientSecret: null,
      error: null,
      success: false
    });
  }

  render() {
    const {
      values,
      errors,
      handleBlur,
    } = this.props;

    const {
      clientSecret,
      error,
      success,
    } = this.state;

    return (
      <Container>
        { !clientSecret && !success && (
        <FormStyled>
          <Container>
            <TextInputStyled
              value={values.stripeAccount}
              type="text"
              onChange={e => this.changeTracker(e, 'stripeAccount')}
              onBlur={handleBlur}
              error={errors.stripeAccount}
              multiline={false}
              placeholder="Enter trainer Stripe account id"
            />
          </Container>
          <Container>
            <TextInputStyled
              value={values.amount}
              type="text"
              onChange={e => this.changeTracker(e, 'amount')}
              onBlur={handleBlur}
              error={errors.amount}
              multiline={false}
              placeholder="Enter amount to transfer"
            />
          </Container>
          <ButtonContainer>
            <ButtonStyled color="primary" variant="contained" onClick={() => this.handleSubmit(values)}>Submit</ButtonStyled>
          </ButtonContainer>
        </FormStyled>
        )}
        { clientSecret && !success && (
          <StripeProvider apiKey={config.stripe.apiKey} stripeAccount={values.stripeAccount}>
            <Elements>
              <PaymentForm clientSecret={clientSecret} onPaymentSubmit={this.handlePaymentSubmit} />
            </Elements>
          </StripeProvider>
        )}
        { success && (
          <>
            <Container>
              <RowStyled>
                <ColumnHeader>Payment successfully submitted.</ColumnHeader>
              </RowStyled>
            </Container>
            <ButtonContainer>
              <ButtonStyled color="primary" variant="contained" onClick={this.resetPaymentForm}>Reset</ButtonStyled>
            </ButtonContainer>
          </>
        )}
        { error && (
          <Container>
            <RowStyled>
              <ColumnHeader>Error getting results. Try again.</ColumnHeader>
            </RowStyled>
          </Container>
        )}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    formBase: formBase,
    isSubmitted: isSubmitted,
    submitExerciseForm: submitExerciseForm,
    setGlobalLoadingSpinner: setGlobalLoadingSpinner,
  }, dispatch)
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues ? props.initialValues : {}),

  handleSubmit: (values, { props, setSubmitting }) => {
    setSubmitting(false);
  },

  displayName: 'BasicForm',
}))(Transfer);
